'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TableRowIdContextProvider: function() {
        return TableRowIdContextProvider;
    },
    tableRowIdContextDefaultValue: function() {
        return tableRowIdContextDefaultValue;
    },
    useTableRowIdContext: function() {
        return useTableRowIdContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const rowIdContext = /*#__PURE__*/ _react.createContext(undefined);
const tableRowIdContextDefaultValue = '';
const useTableRowIdContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(rowIdContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tableRowIdContextDefaultValue;
};
const TableRowIdContextProvider = rowIdContext.Provider;
